import { BUILD_NUMBER } from '../ui/build-info';
import { Brahm } from '../audio/native-bridge';
import { isNativeShell } from '../config/origin';

/** Call the returned acknowledgement immediately after Preact's synchronous render.
 * A microtask observes the committed DOM even while hidden: animation frames can be
 * suspended in exactly the background state in which the APK applies a bundle. */
export function nativeBundleReadyAfterRender(
  ready: () => Promise<unknown> = () => Brahm.bundleReady({ build: BUILD_NUMBER }),
  schedule: (cb: () => void) => void = queueMicrotask,
): () => void {
  let scheduled = false;
  let sent = false;
  return () => {
    if (!isNativeShell() || scheduled) return;
    scheduled = true;
    schedule(() => {
      if (sent) return;
      sent = true;
      // Older dev APKs have no OTA method. Reporting readiness must never break rendering.
      void ready().catch(() => {});
    });
  };
}
